module.exports = __webpack_public_path__ + "static/media/divan.7b3a81c5.png";